<form *ngIf="!env.USE_TAILWIND" [formGroup]="loginForm" (ngSubmit)="login()" ridangoFocusInvalidInput autocomplete="on">
    <p>{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>
    <ridango-form-field class="form-margin-10">
        <input
            ridangoInput
            formControlName="email"
            aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
            ridangoAutofill
            name="email"
            type="email"
            required
            ridangoUntouchOnFocusout
            autocomplete="username" />
        <ridango-label aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}" aria-hidden="true">{{
            'PH_EMAIL' | translate
        }}</ridango-label>

        <ridango-error *ngIf="email.hasError('email') && !email.hasError('required')">
            {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
        </ridango-error>

        <ridango-error *ngIf="email.touched && email.hasError('required')">
            {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
        </ridango-error>
    </ridango-form-field>

    <ridango-form-field class="form-margin-10 password-automated-test">
        <input
            ridangoInput
            formControlName="password"
            ridangoAutofill
            type="{{ showPassword ? 'text' : 'password' }}"
            name="password"
            required
            ridangoUntouchOnFocusout
            autocomplete="current-password" />

        <ridango-label aria-hidden="true">{{ 'PH_PASSWORD' | translate }}</ridango-label>

        <a
            class="show-hide link link--action"
            (click)="togglePassword($event)"
            (keydown.enter)="togglePassword($event)"
            (keydown.space)="togglePassword($event)"
            tabindex="0"
            role="button"
            ridangoSuffix>
            {{ showPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}
        </a>

        <ridango-error *ngIf="password.touched && password.hasError('required')">
            {{ 'LOCAL_INPUT_PASSWORD_MISSING' | translate }}
        </ridango-error>
    </ridango-form-field>

    <a
        class="forgot-password link link--action margin-bottom-20 inline-block"
        (click)="forgot()"
        (keydown.enter)="forgot()"
        (keydown.space)="forgot()"
        role="link"
        tabindex="0">
        {{ 'FORGOT_PASSWORD' | translate }}
    </a>

    <button class="btn btn--maximal btn--primary btn--big" tabindex="0" type="submit">
        {{ 'BTN_LOG_IN' | translate }}
    </button>
</form>

<form *ngIf="env.USE_TAILWIND" [formGroup]="loginForm" (ngSubmit)="login()" ridangoFocusInvalidInput autocomplete="on">
    <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>
    <div formControlNameSelector="email">
        <mat-form-field class="full-width" (click)="emailInput.focus()" appearance="outline">
            <mat-label aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}" aria-hidden="true">{{
                'PH_EMAIL' | translate
            }}</mat-label>
            <input
                #emailInput
                [required]="true"
                [attr.aria-invalid]="email.invalid && email.touched"
                matInput
                ridangoInput
                formControlName="email"
                ridangoAutofill
                type="email"
                name="email"
                autocomplete="email"
                ridangoUntouchOnFocusout
                aria-errormessage="email-error" />
            <mat-error id="email-error" aria-live="polite">
                <ng-container *ngIf="email.touched && email.hasError('email') && !email.hasError('required')">
                    {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                </ng-container>
                <ng-container *ngIf="email.touched && email.errors?.['required']">
                    {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
                </ng-container>
            </mat-error>
            <div class="mr-3 flex items-center justify-center gap-5" *ngIf="showGreenCheck" matSuffix>
                <img *ngIf="loginForm.get('email').valid" src="assets/check_green.svg" />
            </div>
        </mat-form-field>
    </div>

    <div formControlNameSelector="password">
        <mat-form-field class="full-width mb-5" (click)="passwordInput.focus()" appearance="outline">
            <mat-label aria-hidden="true">{{ 'PH_PASSWORD' | translate }}</mat-label>
            <input
                #passwordInput
                [type]="showPassword ? 'text' : 'password'"
                [required]="true"
                [attr.aria-invalid]="password.invalid && password.touched"
                matInput
                ridangoInput
                formControlName="password"
                ridangoAutofill
                type="password"
                name="password"
                title="{{ 'PH_PASSWORD' | translate }}"
                autocomplete="current-password"
                ridangoUntouchOnFocusout
                aria-errormessage="password-error" />

            <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                <button
                    class="vl-app-light:primary pn-light:text-primary pn-app-light:text-primary var-app-light:text-primary text-secondary"
                    [attr.aria-label]="
                        showPassword
                            ? ('HIDE_PASSWORD_ARIA_LABEL' | translate)
                            : ('SHOW_PASSWORD_ARIA_LABEL' | translate)
                    "
                    (click)="togglePassword()"
                    matSuffix
                    type="button">
                    <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <img *ngIf="showGreenCheck && loginForm.get('password').valid" src="assets/check_green.svg" />
            </div>

            <mat-error id="password-error" *ngIf="password.touched && password.hasError('required')" aria-live="polite">
                {{ 'LOCAL_INPUT_PASSWORD_MISSING' | translate }}
            </mat-error>
        </mat-form-field>
    </div>

    <div
        class="flex-align-center var-app-light-dark:text-sm mb-8 flex items-center justify-between text-base lg:mb-5"
        *ngIf="env.IS_MOBILE_APP">
        <div class="col-item w1 checkbox-mobile flex-align-center flex" *ngIf="env.IS_MOBILE_APP">
            <label class="login-checkbox" [attr.aria-label]="'REMEMBER_ME_LABEL' | translate">
                <input
                    class="check-box-input-secondary"
                    id="rememberMeCheckbox"
                    [ngClass]="{ 'check-box-input-primary': env.APP_NAME === 'panevezys' }"
                    (change)="onRememberMeChanged()"
                    role="checkbox"
                    type="checkbox"
                    formControlName="rememberMe" />
                <span
                    class="checkbox-style solid-border rounded-sm border-2 border-ironside_grey bg-white dark:border-contrast-yellow"></span>
                <span class="ml-2 font-medium" aria-hidden="true">{{ 'REMEMBER_ME_LABEL' | translate }}</span>
            </label>
        </div>
        <p class="text-left text-xs font-medium" *ngIf="!env.IS_MOBILE_APP">
            <span class="mr-1">{{ 'REGISTER_DONT_HAVE_ACCOUNT' | translate }}</span>
            <a
                class="pn-light:text-primary pn-app-light:text-primary text-secondary"
                [routerLink]="'/register' | localize">
                {{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}
            </a>
        </p>

        <a
            class="pn-light:text-primary pn-app-light:text-primary var-app-light:text-primary var-app-light-dark:text-sm cursor-pointer font-semibold text-secondary"
            (click)="forgot()"
            (keydown.enter)="forgot()"
            (keydown.space)="forgot()"
            role="link"
            tabindex="0">
            {{ 'FORGOT_PASSWORD' | translate }}
        </a>
    </div>

    <div class="mb-8 flex items-center" *ngIf="!env.IS_MOBILE_APP">
        <ion-button
            class="login-web-button mr-16 w-32 lg:w-64"
            [disabled]="!recaptchaValue && hasRecaptcha"
            [attr.aria-label]="'BTN_LOG_IN' | translate"
            type="submit"
            size="large"
            color="secondary">
            <ion-label class="text-base font-semibold normal-case">
                {{ 'BTN_LOG_IN' | translate }}
            </ion-label>
        </ion-button>

        <a
            class="pn-light:text-primary cursor-pointer text-secondary"
            [attr.aria-label]="'FORGOT_PASSWORD' | translate"
            (click)="forgot()"
            (keydown.enter)="forgot()"
            (keydown.space)="forgot()"
            role="link"
            tabindex="0">
            {{ 'FORGOT_PASSWORD' | translate }}
        </a>
    </div>

    <p class="var-app-light-dark:text-xs/4 var-app-light-dark:font-semibold mb-8 text-left text-base font-medium">
        <span class="mr-1">{{ 'REGISTER_DONT_HAVE_ACCOUNT' | translate }}</span>
        <a
            class="pn-light:text-primary pn-app-light:text-primary var-app-light:text-primary inline-flex items-center gap-1 text-secondary"
            [routerLink]="'/register' | localize">
            {{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}
            <ion-icon class="dark:filter-yellow" name="arrow-forward-sharp"></ion-icon>
        </a>
    </p>

    <re-captcha
        #recaptcha
        *ngIf="hasRecaptcha"
        [formControlName]="recaptcha"
        [siteKey]="siteKey"
        (resolved)="resolved($event)">
    </re-captcha>

    <button
        class="gl-light:bg-blue-alert vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black sr-app-light:bg-[var(--color-secondary)] var-app-light:bg-[var(--color-secondary)] mt-8 h-12 w-full rounded-lg bg-[var(--color-primary)] dark:bg-contrast-yellow dark:text-contrast-black"
        *ngIf="env.IS_MOBILE_APP"
        [disabled]="!recaptchaValue && hasRecaptcha"
        [attr.aria-label]="'BTN_LOG_IN' | translate"
        type="submit">
        <ion-label
            class="gl-light:text-[var(--color-primary)] jk-light:text-white sr-app-light:text-white pn-app-light:text-white pn-light:text-white pn-app-light:text-white text-base font-bold normal-case dark:text-contrast-black">
            {{ 'BTN_LOG_IN' | translate }}
        </ion-label>
    </button>
</form>
